import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="company-admin--lease-auctions--recipient-emails"
export default class extends Controller {
  static targets = [
    "emailDisplay",
    "customerTemplate",
    "customerAndAlternateTemplate",
    "selectRecipientTemplate",
  ]

  connect() {
    this.updateEmailDisplay()
  }

  updateEmailDisplay() {
    const checkedRadio = this.element.querySelector('input[name*="recipient"]:checked')
    const recipientType = checkedRadio?.value

    let templateTarget

    switch (recipientType) {
      case "customer":
        templateTarget = this.customerTemplateTarget
        break
      case "customer_and_alternate_contact":
        templateTarget = this.customerAndAlternateTemplateTarget
        break
      default:
        templateTarget = this.selectRecipientTemplateTarget
    }

    // Clone the template content and display it
    this.emailDisplayTarget.innerHTML = templateTarget.innerHTML
  }
}
